export enum NotificationEventType {
	reservations_updated = 'reservations_updated',
	orders_updated = 'orders_updated',
	messages_updated = 'messages_updated',
}
